import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getDetails } from "../../../Core/Details/action";
import { putData, getData } from "../../../Core/Projects/action";
import CountDown from "../CountDown";
import styles from "../../../Assets/Styles/Components/Book/Details/Details.module.css";

class Details extends Component {
    constructor() {
        super();
        this.state = {
            inputValue: "",
            textarea: "",
            checked: false,
            personsInLine: 0,
        };
    }

    componentDidMount() {
        if (!this.props.project.slug) {
            if (window.location.search && window.location.search.substr(1)) {
                this.props.getData(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug, {});
                this.props.getDetails(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug);
            }
        } else {
            this.props.getDetails(this.props.project.slug);
        }
        this.rndInteger();
        setTimeout(() => {
            this.setState((preState) => ({ personsInLine: preState.personsInLine + 1 }));
        }, 5000);
    }

    componentDidUpdate(preProps) {
        if (
            (this.props.project && this.props.project.data && preProps.project.data.step !== this.props.project.data.step) ||
            (this.props.project && !this.props.project.loading && preProps.project.loading !== this.props.project.loading)) {
            this.props.history.push(`/book/${this.props.project.data.step}?slug=${this.props.project.slug}`);
        }
    }

    rndInteger = () => {
        this.setState({ personsInLine: Math.floor(Math.random() * (10 - 3 + 1)) + 3 });
    }

    handleinputChange = (e) => {
        // e.target.value.trim() !== "" &&
        this.setState({ inputValue: e.target.value });
    }

    handleTextChange = (e) => {
        this.setState({ textarea: e.target.value });
    }

    handleCheckboxChange = () => {
        this.setState({ checked: !this.state.checked });
    }

    goNext = () => {
        const { slug, data } = this.props.project;
        const { user_display_name } = this.props.project.data;
        const { textarea, inputValue } = this.state;
        const newData = { ...data, shoot_detail: textarea, step: this.props.history.location.pathname.slice(1).split('/')[1] };
        user_display_name === null && (newData.user_display_name = inputValue);
        this.props.putData(slug, newData);
    }

    render() {
        const { photographer, phone, clientName } = this.props.details.details;
        const { user_display_name } = this.props.project.data;
        const { inputValue, textarea, checked, personsInLine } = this.state;
        return (
            <div className={`container ${styles.clientContainer}`}>
                <div className="row">
                    <div className="col-12">
                        <div className="custom-box">
                            <div className="row">
                                {(!user_display_name || user_display_name === "") && (
                                    <>
                                        <div className="col-12">
                                            <h2> اطلاعات شما </h2>
                                        </div>
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <input
                                                        type="text"
                                                        value={user_display_name && user_display_name !== "" ? user_display_name : inputValue}
                                                        disabled={user_display_name && user_display_name !== ""}
                                                        onChange={this.handleinputChange}
                                                        className={inputValue === "" && user_display_name === null ? styles.borderErr : ""}
                                                    />
                                                    {(inputValue === "" && user_display_name === null) && <p className={styles.error}>لطفا نام و نام خانوادگی خود را وارد کنید.</p>}
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <input type="text" value={phone} disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="col-12">
                                    <br />
                                    <div className="row">
                                        <div className="col-12">
                                            <h3> جزئیات سفارش مورد نیاز شما: </h3>
                                            <textarea
                                                type="text"
                                                required
                                                value={textarea}
                                                onChange={this.handleTextChange}
                                                placeholder="هر آنچه که نیاز دارید را برای متخصص بنویسید. ژست خاص، تجهیزات نورپردازی، دکور یا  لینک به نمونه های مشابه را اینجا وارد کنید."
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row">
                                        <div className={`col-12 ${styles.justCenter}`}>
                                            <input
                                                type="checkbox"
                                                value={checked}
                                                onChange={this.handleCheckboxChange}
                                            />
                                            <span> من <a href="https://kadro.co/terms/" target="_blank" rel="noreferrer"> &quot;شرایط و قوانین&quot; </a> کادرو را می‌پذیرم.</span>
                                        </div>
                                    </div>
                                    <div className="row align-items-center">
                                        <div className="col-12 my-4 text-center" style={{ textAlign: "right" }}>
                                            <p className="p-2" style={{ fontSize: "12px" }}> <i className="far fa-phone" /> { }پس از پرداخت، امکان تماس و هماهنگی مستقیم با متخصص فراهم می‌شود.</p>
                                            <p className="p-2" style={{ fontSize: "12px" }}> <i className="far fa-check" /> { } حضور متخصص در زمان رزرو، پس از تأیید نهایی در سیستم کادرو تضمین می‌شود.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-8 col-md-6">
                                            <div className={`${styles.btnSelect} ${(checked && (inputValue !== "" || user_display_name !== null)) ? "" : styles.deactive}`} onClick={(checked && (inputValue !== "" || user_display_name !== null)) && this.goNext}>مرحله بعد </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        details: state.details,
        project: state.project
    };
};
export default connect(mapStateToProps, { getDetails, putData, getData })(withRouter(Details));
